import React, { useEffect, useRef, useState } from "react";

// Lightweight count-up number. Respects reduced motion (shows final value).
export const CountUp = ({ value = 0, duration = 800, reduced = false, className = "" }) => {
  const [display, setDisplay] = useState(reduced ? value : 0);
  const raf = useRef(null);
  useEffect(() => {
    if (reduced) { setDisplay(value); return; }
    const start = performance.now();
    const from = 0;
    const step = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(from + (value - from) * eased));
      if (p < 1) raf.current = requestAnimationFrame(step);
    };
    raf.current = requestAnimationFrame(step);
    return () => raf.current && cancelAnimationFrame(raf.current);
  }, [value, duration, reduced]);
  return <span className={className}>{display}</span>;
};

export default CountUp;
